import React, { useEffect, useRef } from 'react'
// Tools
import { useDispatch, connect } from 'react-redux'

// Components
import { CrearAlertaForm } from './CrearAlertaForm'
import { FormTitle } from './FormTitle'
import { CreateAlertaSuccess } from './CreateAlertaSuccess'
import { reduceFilters } from './filter-reducer'
import { SuccessTitle } from './SuccessTitle'

// Tracking
import { DataLayer } from '../../../constants/gtm-events-alertasv2'

// Store
import { createAlertResetAction, createAlertAction, getAlertasFrecuencia } from '../../../redux/actions/alerts-v2'
import { hideModal } from '../../../redux/actions/modal'
import { FiltersState } from '../../../redux/types/filters'
import { ModalState } from '../../../redux/types/modal'
import { AlertState } from '../../../redux/types/alert-v2'

// Styles
import { ModalComponent } from './mixins'

export interface AlertFormData {
  nombre: string
  idFrecuencia: number
}

interface ModalAlertProps {
  filtersApplied: FiltersState['filtersApplied']
  frequencies: AlertState['alertasFrecuencia']
  createAlert: AlertState['create']
  visible: boolean
}

const ModalAlerta = ({ visible, filtersApplied, frequencies, createAlert }: ModalAlertProps) => {
  // Hooks
  const dispatch = useDispatch()
  const frecuenciaSeleccionada = useRef<number>()
  const handleTrackingCreation = (idFrecuencia, filters) => {
    DataLayer.handlerCreateAlertTraking({
      idFrecuencia: idFrecuencia.current,
      area: filters.area,
      subarea: filters.subarea,
      localidad: filters.localidad,
      provincia: filters.provincia,
      tipoTrabajo: filters.tipoTrabajo,
      modalidadTrabajo: filters.modalidadTrabajo,
      nivelLaboral: filters.nivelLaboral,
      discapacidad: filters.discapacidad,
    })
  }

  // Effect - Lanza evento de creacion de alerta
  useEffect(() => {
    if (createAlert.status.success) {
      if (createAlert.value?.code === 'SUCCESS') {
        const filters = reduceFilters(filtersApplied)
        handleTrackingCreation(frecuenciaSeleccionada, filters)
      } else {
        DataLayer.handlerShowModalAlertTraking(createAlert.value?.code)
      }
    }
  }, [createAlert])

  // Handler - Obtener estaticos de frecuencias
  const getFrecuenciasHandler = () => {
    dispatch(getAlertasFrecuencia())
  }

  // Handler - Crear alerta
  const createAlertHandler = (data: AlertFormData) => {
    const filters = reduceFilters(filtersApplied)
    frecuenciaSeleccionada.current = data.idFrecuencia
    dispatch(
      createAlertAction({
        nombre: data.nombre,
        idFrecuencia: data.idFrecuencia,
        keyword: filters.keyword,
        area: filters.area,
        subarea: filters.subarea,
        provincia: filters.provincia,
        localidad: filters.localidad,
        nivelLaboral: filters.nivelLaboral,
        tipoTrabajo: filters.tipoTrabajo,
        modalidadTrabajo: filters.modalidadTrabajo,
        tipoContratacion: filters.tipoContratacion,
        discapacidad: filters.discapacidad,
      })
    )
  }

  // Handler - Cerrar modal
  const closeModalHandler = () => {
    dispatch(hideModal())
    dispatch(createAlertResetAction())
  }

  // Arma que titulo del modal
  const title = createAlert.status.success && createAlert.value?.code === 'SUCCESS' ? <SuccessTitle /> : <FormTitle />

  // Arma el cuerpo del modal
  const getModalBody = () => {
    const body =
      createAlert.status.success && createAlert.value?.code === 'SUCCESS' ? (
        <CreateAlertaSuccess idFrecuencia={createAlert.value.idFrecuencia} closeHandler={closeModalHandler} />
      ) : (
        <CrearAlertaForm
          frequencies={frequencies}
          createAlertHandler={createAlertHandler}
          closeHandler={closeModalHandler}
          getFrecuenciasHandler={getFrecuenciasHandler}
          createAlert={createAlert}
        />
      )
    return body
  }

  return (
    <ModalComponent width={596} visible={visible} onClose={closeModalHandler} title={title}>
      {getModalBody()}
    </ModalComponent>
  )
}

const states = ({
  modalStore,
  filtersStore,
  alertsV2Store,
}: {
  filtersStore: FiltersState
  modalStore: ModalState
  alertsV2Store: AlertState
}) => ({
  filtersApplied: filtersStore.filtersApplied,
  frequencies: alertsV2Store.alertasFrecuencia,
  visible: modalStore.activeModal === 'modal-crear-alerta',
  createAlert: alertsV2Store.create,
})

export default connect(states)(ModalAlerta)
